<template>
  <VueApexCharts 
      v-show="streamAlive && isAllowed" 
      ref="chart" :options="options" 
      :series="series"
      type="line"
      @mouseMove="onMouseMove"
      @mouseLeave="mouseLeave"
      @legendClick="onLegendClick"
    >
  </VueApexCharts>
  <div v-if="!streamAlive || !isAllowed" class="offline-banner">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05258 16.501L12.404 10.0669C12.3021 9.78866 12.2466 9.48819 12.2466 9.17467C12.2466 7.74124 13.4086 6.57928 14.842 6.57928C16.248 6.57928 17.3927 7.69725 17.4361 9.09272L23.2464 11.1269C23.7224 10.5681 24.4312 10.2137 25.2227 10.2137C25.6694 10.2137 26.0896 10.3265 26.4566 10.5251L33.1549 4.80209C33.0599 4.53225 33.008 4.24209 33.008 3.93975C33.008 2.50639 34.1701 1.34436 35.6034 1.34436C37.037 1.34436 38.199 2.50639 38.199 3.93975C38.199 5.37327 37.037 6.5353 35.6034 6.5353C35.1569 6.5353 34.7366 6.42249 34.3697 6.22381L27.6713 11.9469C27.7663 12.2167 27.8182 12.5069 27.8182 12.8092C27.8182 14.2426 26.6562 15.4046 25.2227 15.4046C23.8167 15.4046 22.672 14.2866 22.6287 12.8912L16.8184 10.857C16.3423 11.4158 15.6336 11.7703 14.842 11.7703C14.4061 11.7703 13.9955 11.6627 13.6348 11.4729L6.28344 17.9069C6.38531 18.1851 6.44086 18.4857 6.44086 18.7992C6.44086 20.2327 5.27883 21.3946 3.84531 21.3946C2.41203 21.3944 1.25 20.2326 1.25 18.799C1.25 17.3655 2.41203 16.2037 3.84539 16.2037C4.28125 16.2037 4.69195 16.3112 5.05258 16.501ZM33.6291 11.6608C32.9837 11.6608 32.4572 12.1873 32.4572 12.8327V36.749C32.4572 37.3944 32.9837 37.9208 33.6291 37.9208H37.5781C38.2237 37.9208 38.7501 37.3944 38.7501 36.749V12.8327C38.7501 12.1873 38.2238 11.6608 37.5781 11.6608H33.6291ZM23.2482 21.2179C22.6027 21.2179 22.0764 21.7443 22.0764 22.3897V36.994C22.0764 37.6395 22.6028 38.1658 23.2482 38.1658H27.1974C27.8429 38.1658 28.3692 37.6394 28.3692 36.994C28.3692 32.126 28.3692 27.2579 28.3692 22.3897C28.3692 21.7443 27.8429 21.2179 27.1974 21.2179C25.8809 21.2179 24.5647 21.2179 23.2482 21.2179ZM12.8675 17.7869C12.222 17.7869 11.6955 18.3133 11.6955 18.9587V37.239C11.6955 37.8844 12.2219 38.4108 12.8675 38.4108H16.8166C17.462 38.4108 17.9884 37.8844 17.9884 37.239V18.9587C17.9884 18.3133 17.462 17.7869 16.8166 17.7869H12.8675ZM2.48672 27.8741H6.4357C7.08117 27.8741 7.60766 28.4005 7.60766 29.046V37.4839C7.60766 38.1294 7.08117 38.6558 6.4357 38.6558H2.48672C1.84125 38.6558 1.31477 38.1294 1.31477 37.4839V29.046C1.31484 28.4005 1.84133 27.8741 2.48672 27.8741Z" fill="#404B72"/>
    </svg>
    <div v-if="!isAllowed" class="mt-4">
      <p class="mb-0 text-s-m"><a target="_blank" class="text-reset text-underline" href="/app/subscribe">Upgrade</a> plan to view this statistic.</p>
    </div>
    <div class="mt-4" v-else>You're offline</div>
  </div>
  <div class="chart-tooltip" v-show="showTooltip" v-follow-tooltip="'apexcharts-tooltip'" :style="tooltipStyle">
    <div class="series-1">
      <span class="apexcharts-legend-marker" rel="1" data:collapsed="false" style="background: rgb(32, 118, 255); color: rgb(32, 118, 255); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 4px;"></span>
      <span>Avg. Bitrate</span>
      <span class="tooltip-value">{{ tooltipAvgBitrate }}</span>
    </div>
    <div class="series-2">
      <span class="apexcharts-legend-marker" rel="2" data:collapsed="false" style="background: rgb(240, 111, 157); color: rgb(240, 111, 157); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 4px;"></span>
      <span>Bitrate</span>
      <span class="tooltip-value">{{ tooltipBitrate }}</span>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
import moment from "moment";
import _ from "lodash";

export default {
  name: "MonitoringChart",
  components: {
    VueApexCharts,
  },
  props: {
    streamKey: {
      type: String,
      default: "",
    },
    streamAlive: {
        type: Boolean,
        default: false,
    },
    isAllowed: {
      type: Boolean,
      default: false,
    },
    legendPosition: {
      type: String,
      default: "top",
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    console.log('monitoring chart mounted');
    if(this.isAllowed) {
      this.wsConnect();
      // setTimeout(() => {
      //   this.wsDisconnect();
      // }, 5000)
    }
  },
  beforeDestroy () {
    console.log('monitoring chart destroyed');
    this.wsDisconnect();
  },
  data() {
    return {
      options: {
        chart: {
          id: 'monitoring-chart',
          type: 'line',
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              enabled: true,
              speed: 1000
            }
          },
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false,
          },
        },
        legend: {
          position: this.legendPosition,
          fontSize: '12px',
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",      
          horizontalAlign: 'left',
          labels: {
            colors: ["#8794B5", "#8794B5"],
          },
          markers: {
              size: 4,
              shape: 'square', // circle, square, line, plus, cross
              radius: 4,
          },
        },
        xaxis: {
          type: 'datetime',
          range: 60000,
          stepSize: 30000,
          labels: {
            datetimeUTC: false,
            showDuplicates: false,
            style: {
                colors: "#8794B5",
                fontSize: '12px',
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
          },  
        },
        yaxis: {
          decimalsInFloat: 0,
          min: 0,
          title: {
            text: 'Bitrate (kbps)',
            style: {
                color: "#8794B5",
                fontSize: '12px',
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
          },
          labels: {
            style: {
                colors: ["#8794B5"],
                fontSize: '12px',
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
          },
        },
        tooltip: {
          enabled: this.tooltip,
          theme: 'dark',
        },
        grid: {
          show: false,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: [1, 1],
        },
        fill: {
          type:'solid',
          opacity: [0.35, 0.35],
        },
      },
      series: [{
        name: 'Avg Bitrate',
        type: 'area',
        color: '#2076FF',
        data: []
      }, {
        name: 'Bitrate',
        color: '#F06F9D',
        type: 'area',
        data: []
      }],
      avgBitrateData: [],
      bitrateData: [],
      retryCounter: 0,
      movingAverage: 0,
      pointCounter: 0,
      refreshCounter: 0,
      showTooltip: false,
      isAvgBitrateHidden: false,
      isBitrateHidden: false,
      tooltipPosition: {
        x: 0,
        y: 0,
      },
      tooltipStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px',
      },
      tooltipAvgBitrate: 0,
      tooltipBitrate: 0,
    };
  },
  methods: {
    dataPointMouseEnter(event, chartContext, opts) {
    },
    onMouseMove(event, chartContext, opts) {
      if(opts.dataPointIndex < 0) return;
      this.showTooltip = true;
      if(this.series[0]?.data[opts?.dataPointIndex]?.[1]) this.tooltipAvgBitrate = this.series[0]?.data[opts.dataPointIndex]?.[1]?.toFixed(0);
      if(this.series[1]?.data[opts?.dataPointIndex]?.[1]) this.tooltipBitrate = this.series[1].data[opts.dataPointIndex]?.[1]?.toFixed(0);
    },
    onLegendClick(chartContext, seriesIndex, opts) {
      console.log(this.$refs.chart, chartContext);
      
      if(seriesIndex === 0) {
        this.isAvgBitrateHidden = !this.isAvgBitrateHidden;
      } else if(seriesIndex === 1) {
        this.isBitrateHidden = !this.isBitrateHidden;
      }
    },
    mouseLeave(event, chartContext, opts) {
      this.showTooltip = false;
    },
    wsConnect() {
        if(!this.streamKey) return;
        this.ws = new WebSocket(`wss://stats.castr.io/beats/${this.streamKey}`);
        this.ws.onopen = () => {
            console.log('WebSocket connection established');
            this.retryCounter = 0;
            this.pointCounter = 0;
            this.movingAverage = 0;
        }

        this.ws.onmessage = this.onMessage.bind(this);

        this.ws.onerror = (err) => {
            console.log('[SOCK_ERR]', err);
            this.ws.close();
        }

        this.ws.onclose = () => {
            console.log('[SOCK]: connection closed.');
            this.ws = null;
        }
    },
    wsDisconnect() {
        if(this.ws) {
            this.ws.close?.();
        }
    },
    onMessage() {
        if(typeof event.data !== 'string') return;
        const data = JSON.parse(event.data);
        if (data.message === "Stream not found") {
            console.log('Stream not found, retrying...');
            this.retryConnection();
        } else if (data.data) {
            if(data.data.length) {
                this.parseData(data.data);
            }
        }
    },
    retryConnection() {
        if(this.retryCounter >= 10) return;
        this.retryCounter++;
        setTimout(this.wsConnect, 500 * this.retryCounter);
    },
    parseData(data) {
        let raw = [];
        let avg = [];

        for (const point of data) {
            const ts = point[0];
            if(this.series[1].data.length && ts <= this.series[1].data[this.series[1].data.length - 1][0]) continue;

            const bitrate = point[1] / 1024;
            this.pointCounter++;

            this.movingAverage = this.movingAverage + (bitrate - this.movingAverage) / this.pointCounter;

            raw.push([ts, bitrate]);
            avg.push([ts, this.movingAverage]);
        }

        // this.series[0].data.push(...avg);
        // this.series[1].data.push(...raw);



        const index = this.series[1].data.length - 1;
        if(index >= 0) {
          const min = 60000;
          const trigger = this.series[1].data[index][0] - min * 2;
          const oneMinAgo = this.series[1].data[index][0] - min;
          if(this.series[1].data.length && this.series[1].data[0][0] < trigger) {
            const avgData = this.series[0].data.slice().filter(x => x[0] >= oneMinAgo);
            const rawData = this.series[1].data.slice().filter(x => x[0] >= oneMinAgo);
            this.series[0].data = avgData;
            this.series[1].data = rawData;
          }
        }
        this.series[0].data.push(...avg);
        this.series[1].data.push(...raw);

        if(this.isAvgBitrateHidden) {
          this.$nextTick(() => {
            this.options.chart.animations.enabled = false;
            this.$refs.chart.hideSeries(this.series[0].name);
            this.$nextTick(() => {
              this.options.chart.animations.enabled = false;
            })
          });
        }

        if(this.isBitrateHidden) {
          this.$nextTick(() => {
            this.options.chart.animations.enabled = false;
            this.$refs.chart.hideSeries(this.series[1].name);
            this.$nextTick(() => {
              this.options.chart.animations.enabled = false;
            })
          })
        }
    }
  },
  computed: {
  },
  directives: {
    followTooltip: {
      bind(el, binding, vnode) {
        const tooltipClass = binding.value;
        
        const updateTooltipPosition = () => {
          const thirdPartyTooltip = document.querySelector(`.${tooltipClass}`);
          if (thirdPartyTooltip) {
            const rect = thirdPartyTooltip.getBoundingClientRect();
            if(Array.from(thirdPartyTooltip.classList).includes('apexcharts-active') && rect.top && rect.left) {
              vnode.context.tooltipStyle.top = `${rect.top + window.scrollY}px`;
              vnode.context.tooltipStyle.left = `${rect.left + window.scrollX}px`;
            }
          }
        };

        el._interval = setInterval(updateTooltipPosition, 10);
      },
      unbind(el) {
        clearInterval(el._interval);
      },
    },
  },
  watch: {
    isAllowed(newState) {
      if(newState && !this.ws) {
        this.wsConnect();
      }
    }
  },
};
</script>
<style>
#container {
  height: 350px;
}

.offline-banner {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--c-dark-8);
    padding: 0;
}

.apexcharts-tooltip {
    background: var(--surface-2);
    color: var(--c-dark-8);
    opacity: 0 !important;
  }

 .chart-tooltip {
    /* background: var(--surface-2); */
    background: rgba(0, 0, 0, 0.7);
    color: var(--c-dark-8);
    font-size: 12px;
    padding: 8px;
 }

 .tooltip-value {
    font-weight: bold;
    margin-left: 8px;
 }
</style>